/**
 * ============================================================
 * ABAYA LUXURY — Product Page JavaScript
 * File: assets/abaya-product.js
 * Gallery · Variant switching · Accordions · Tabs · ATC
 * ============================================================
 */

(function () {
  'use strict';

  /* ── HELPERS ──────────────────────────────────────────────── */
  function $(selector, context) {
    return (context || document).querySelector(selector);
  }

  function $$(selector, context) {
    return Array.from((context || document).querySelectorAll(selector));
  }

  function on(el, event, fn) {
    if (el) el.addEventListener(event, fn);
  }

  /* ── 1. IMAGE GALLERY ─────────────────────────────────────── */
  function initGallery() {
    $$('.abaya-product').forEach(function (product) {
      var thumbs = $$('.abaya-product__thumb', product);
      var images = $$('.abaya-product__img', product);
      var dots   = $$('.abaya-product__dot', product);

      /* Fixed 2026-08: currentIndex used to live only inside the
         touch handler below, so it never learned about taps on the
         dots or thumbnails. Tapping to image 4 then swiping jumped
         back to image 1, because the swipe was still counting from
         a stale 0. It's now the single source of truth, updated by
         every path that changes the image. */
      var currentIndex = 0;

      function setActive(index) {
        currentIndex = index;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        images.forEach(function (img) {
          img.classList.remove('is-active');
          img.style.position = 'absolute';
          img.style.opacity = '0';
        });
        dots.forEach(function (d) { d.classList.remove('is-active'); });

        if (thumbs[index])  thumbs[index].classList.add('is-active');
        if (dots[index])    dots[index].classList.add('is-active');

        if (images[index]) {
          images[index].classList.add('is-active');
          images[index].style.position = 'relative';
          images[index].style.opacity = '1';
        }
      }

      thumbs.forEach(function (thumb, i) {
        on(thumb, 'click', function () { setActive(i); });
        on(thumb, 'mouseenter', function () { setActive(i); });
      });

      dots.forEach(function (dot, i) {
        on(dot, 'click', function () { setActive(i); });
      });

      // Mobile swipe
      var imageWrap = $('.abaya-product__image-wrap', product);
      if (imageWrap) {
        var startX = 0;

        on(imageWrap, 'touchstart', function (e) {
          startX = e.touches[0].clientX;
        });

        on(imageWrap, 'touchend', function (e) {
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) < 40) return;
          if (diff > 0 && currentIndex < images.length - 1) {
            currentIndex++;
          } else if (diff < 0 && currentIndex > 0) {
            currentIndex--;
          }
          setActive(currentIndex);
        });
      }
    });
  }

  /* ── 2. VARIANT SWITCHING ─────────────────────────────────── */
  function initVariantSwitching() {
    $$('.abaya-product').forEach(function (product) {
      var form       = $('[id^="abaya-product-form"]', product);
      var variantInput = $('[id^="abaya-variant-id"]', product);
      if (!form || !variantInput) return;

      var productData = null;

      // Attempt to read product JSON from page (Dawn renders this)
      var productJson = $('[id^="ProductJson"], script[type="application/json"]', product);
      try {
        if (productJson) productData = JSON.parse(productJson.textContent);
      } catch (e) {}

      // Colour swatches
      var swatches = $$('.abaya-product__swatch', product);
      swatches.forEach(function (swatch) {
        on(swatch, 'click', function () {
          var input = $('input[type="radio"]', swatch);
          if (!input) return;
          swatches.forEach(function (s) { s.classList.remove('is-selected'); });
          swatch.classList.add('is-selected');

          // Update displayed colour name
          var selectedDisplay = $('[id^="selected-color"]', product);
          if (selectedDisplay) selectedDisplay.textContent = '— ' + input.value;

          updateVariant(product, form, variantInput);
        });
      });

      // Size buttons
      var sizeBtns = $$('.abaya-product__size-btn', product);
      sizeBtns.forEach(function (btn) {
        if (btn.classList.contains('is-sold-out')) return;
        on(btn, 'click', function () {
          var input = $('input[type="radio"]', btn);
          if (!input) return;
          sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');

          var selectedDisplay = $('[id^="selected-size"]', product);
          if (selectedDisplay) selectedDisplay.textContent = '— ' + input.value;

          updateVariant(product, form, variantInput);
        });
      });
    });
  }

  function updateVariant(product, form, variantInput) {
    var selectedOptions = {};
    var radios = $$('input[type="radio"]:checked', form);
    radios.forEach(function (r) {
      selectedOptions[r.name] = r.value;
    });

    // Try to match variant via Shopify AJAX if we don't have product JSON
    var params = Object.values(selectedOptions).join(' / ');
    if (params) {
      var handle = window.location.pathname.replace('/products/', '').replace('/', '');
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var matched = data.variants.find(function (v) {
            var titleCheck = Object.values(selectedOptions).every(function (opt) {
              return v.title.indexOf(opt) !== -1;
            });
            return titleCheck;
          });

          if (!matched) return;

          // Update hidden variant ID
          variantInput.value = matched.id;

          // Update price
          updatePrice(product, matched);

          // Update ATC button
          updateATCButton(product, matched);

          // Update main image if variant has one
          if (matched.featured_image) {
            var imgIndex = -1;
            $$('.abaya-product__img', product).forEach(function (img, i) {
              if (img.src && img.src.indexOf(matched.featured_image.src) !== -1) {
                imgIndex = i;
              }
            });
            if (imgIndex > -1) {
              $$('.abaya-product__thumb', product)[imgIndex] &&
              $$('.abaya-product__thumb', product)[imgIndex].click();
            }
          }

          // Update URL without reload
          var url = new URL(window.location.href);
          url.searchParams.set('variant', matched.id);
          window.history.replaceState({}, '', url.toString());
        })
        .catch(function (err) {
          console.warn('Abaya variant fetch error:', err);
        });
    }
  }

  function updatePrice(product, variant) {
    var priceEl = $('.abaya-product__price--current', product);
    var compareEl = $('.abaya-product__price--compare', product);
    var noteEl = $('.abaya-product__price-note', product);

    if (!priceEl) return;

    var formatMoney = function (cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    priceEl.textContent = formatMoney(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (noteEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var saving = variant.compare_at_price - variant.price;
        noteEl.textContent = 'You save ' + formatMoney(saving);
        noteEl.style.display = '';
      } else {
        noteEl.style.display = 'none';
      }
    }
  }

  function updateATCButton(product, variant) {
    var btn = $('.abaya-product__atc-btn', product);
    var txt = $('.abaya-product__atc-text', btn);
    if (!btn || !txt) return;

    if (variant.available) {
      btn.disabled = false;
      btn.classList.remove('is-sold-out');
      txt.textContent = 'Add to Bag';
    } else {
      btn.disabled = true;
      btn.classList.add('is-sold-out');
      txt.textContent = 'Sold Out';
    }

    syncStickyATC();
  }

  /* Added 2026-08: the mobile sticky bar had "Add to Bag" hardcoded
     into its markup and never updated. Selecting a sold-out variant
     left the sticky bar cheerfully offering to add it, and tapping
     did nothing (it forwards the click to the real button, which is
     disabled) — a dead control with no explanation. Mirror the real
     button's state instead. */
  function syncStickyATC() {
    var realBtn = $('.abaya-product__atc-btn:not(.abaya-sticky-atc__btn)');
    var stickyBtn = $('.abaya-sticky-atc__btn');
    if (!realBtn || !stickyBtn) return;

    var realTxt = $('.abaya-product__atc-text', realBtn);
    var label = realTxt ? realTxt.textContent : realBtn.textContent;
    var stickyLabel = stickyBtn.querySelector('span') || stickyBtn;

    stickyLabel.textContent = (label || '').trim() || 'Add to Bag';
    stickyBtn.disabled = realBtn.disabled;
    stickyBtn.classList.toggle('is-sold-out', realBtn.classList.contains('is-sold-out'));
  }

  /* ── 3. QUANTITY STEPPER ──────────────────────────────────── */
  function initQtyStepper() {
    $$('.abaya-product').forEach(function (product) {
      var input = $('[id^="qty-input"]', product);
      var minus = $('[id^="qty-minus"]', product);
      var plus  = $('[id^="qty-plus"]', product);
      if (!input) return;

      on(minus, 'click', function () {
        var val = parseInt(input.value, 10);
        if (val > 1) input.value = val - 1;
      });

      on(plus, 'click', function () {
        var val = parseInt(input.value, 10);
        if (val < 10) input.value = val + 1;
      });
    });
  }

  /* ── 4. ADD TO CART FEEDBACK ──────────────────────────────── */
  function initATCFeedback() {
    $$('[id^="abaya-product-form"]').forEach(function (form) {
      on(form, 'submit', function (e) {
        var btn = $('.abaya-product__atc-btn', form.closest('.abaya-product'));
        var txt = btn && $('.abaya-product__atc-text', btn);
        if (!btn || !txt) return;

        var original = txt.textContent;

        btn.disabled = true;
        btn.classList.add('is-adding');
        txt.textContent = 'Adding…';

        setTimeout(function () {
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
          txt.textContent = '✦ Added to Bag';
        }, 500);

        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
          txt.textContent = original;
        }, 2500);
      });
    });
  }

  /* ── 5. ACCORDIONS ────────────────────────────────────────── */
  function initAccordions() {
    $$('.abaya-accordion__trigger').forEach(function (trigger) {
      on(trigger, 'click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var body = trigger.nextElementSibling;

        trigger.setAttribute('aria-expanded', !expanded);
        if (body) body.classList.toggle('is-open', !expanded);
      });
    });
  }

  /* ── 6. TABS ──────────────────────────────────────────────── */
  function initTabs() {
    $$('.abaya-product__tabs').forEach(function (tabBar) {
      var tabs   = $$('.abaya-tab', tabBar);
      var panels = $$('.abaya-tab-panel', tabBar.closest('.abaya-product__tabs-section'));

      tabs.forEach(function (tab, i) {
        on(tab, 'click', function () {
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.setAttribute('aria-hidden', 'true');
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          if (panels[i]) {
            panels[i].classList.add('is-active');
            panels[i].removeAttribute('aria-hidden');
          }
        });
      });
    });
  }

  /* ── 7. (removed) SIZE GUIDE TOGGLE ───────────────────────────
     The inline size-guide panel was removed from the section in
     2026-08 — measurements differ per abaya and are given in each
     product's description instead. initSizeGuide() and its call in
     init() went with it; nothing else referenced #size-guide.
  ──────────────────────────────────────────────────────────── */

  /* ── 8. WISHLIST TOGGLE ───────────────────────────────────── */
  function initWishlist() {
    $$('[id^="wishlist-btn"]').forEach(function (btn) {
      on(btn, 'click', function () {
        btn.classList.toggle('is-active');
        var isActive = btn.classList.contains('is-active');
        btn.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');

        // Could POST to a wishlist app endpoint here
        // e.g. fetch('/apps/wishlist/add', { method: 'POST', body: JSON.stringify({ productId: ... }) })

        // Visual feedback
        btn.style.transform = 'scale(1.2)';
        setTimeout(function () { btn.style.transform = ''; }, 200);
      });
    });
  }

  /* ── 9. STICKY ATC ON MOBILE / TABLET ─────────────────────────
     Fixed 2026-08: previously this bailed out based on a single
     matchMedia() check made once at page load, so a tablet
     rotated from landscape (>=990px, no bar) to portrait
     (<990px) never got the bar, and vice versa. It also rebuilt
     the bar/style/observer from scratch on every
     shopify:section:load, stacking duplicate fixed bars in the
     theme editor. Now the bar is created once (idempotent) and
     hidden purely via a CSS media query, so it tracks the
     viewport live; the observer is re-targeted only if the ATC
     row element actually changed.
  ──────────────────────────────────────────────────────────── */
  var stickyATCObserver = null;
  var stickyATCRow = null;

  function initStickyATC() {
    var atcRow = $('.abaya-product__atc-row');
    if (!atcRow) return;

    var stickyBar = $('.abaya-sticky-atc');
    if (!stickyBar) {
      stickyBar = document.createElement('div');
      stickyBar.className = 'abaya-sticky-atc';
      stickyBar.innerHTML = '<button type="button" class="abaya-product__atc-btn abaya-sticky-atc__btn"><span>Add to Bag</span></button>';
      document.body.appendChild(stickyBar);
    }

    if (!document.getElementById('abaya-sticky-atc-style')) {
      var stickyStyle = document.createElement('style');
      stickyStyle.id = 'abaya-sticky-atc-style';
      stickyStyle.textContent = [
        '.abaya-sticky-atc { position: fixed; bottom: 0; left: 0; right: 0; padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px)); background: rgba(253,250,246,0.96); backdrop-filter: blur(8px); border-top: 1px solid rgba(201,168,76,0.2); z-index: 100; transform: translateY(100%); transition: transform 350ms cubic-bezier(0.16,1,0.3,1); }',
        '.abaya-sticky-atc.is-visible { transform: translateY(0); }',
        '.abaya-sticky-atc__btn { width: 100%; height: 48px; }',
        /* Hide entirely at desktop widths — CSS reacts to live
           viewport/orientation changes, no JS re-check needed. */
        '@media screen and (min-width: 990px) { .abaya-sticky-atc { display: none !important; } }'
      ].join('\n');
      document.head.appendChild(stickyStyle);
    }

    // Bind the click-through only once per bar.
    var stickyBtn = $('.abaya-sticky-atc__btn', stickyBar);
    if (stickyBtn && !stickyBtn.dataset.bound) {
      stickyBtn.dataset.bound = 'true';
      on(stickyBtn, 'click', function () {
        var realBtn = $('.abaya-product__atc-btn:not(.abaya-sticky-atc__btn)');
        if (realBtn) realBtn.click();
      });
    }

    // Re-target the observer only if the ATC row element changed
    // (e.g. a Shopify section reload swapped in fresh markup).
    if (stickyATCRow !== atcRow) {
      if (stickyATCObserver) stickyATCObserver.disconnect();

      stickyATCObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0.5 });

      stickyATCObserver.observe(atcRow);
      stickyATCRow = atcRow;
    }

    // Reflect the real button's initial state (e.g. landing on a
    // sold-out variant via ?variant= in the URL).
    syncStickyATC();
  }

  /* ── 10a. DYNAMIC STICKY-GALLERY OFFSET ───────────────────────
     Fixed 2026-08: .abaya-product__gallery used a hardcoded
     `top: 80px` for its position:sticky offset. The real header
     height varies (announcement bar on/off, nav wrapping to two
     lines on narrow desktop windows, theme-editor header setting
     changes) — a static guess drifts out of sync and either
     leaves a gap under the header or lets the gallery slide
     underneath it. This measures the actual rendered header and
     writes it to a CSS variable the stylesheet reads, so it
     always matches, on load and on every resize.
  ──────────────────────────────────────────────────────────── */
  function initStickyGalleryOffset() {
    var header = $('.shopify-section-header') || $('.header');
    if (!header) return;

    var raf = null;
    function setOffset() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        var height = header.getBoundingClientRect().height;
        document.documentElement.style.setProperty(
          '--sticky-gallery-offset',
          Math.round(height + 16) + 'px'
        );
        raf = null;
      });
    }

    setOffset();
    window.addEventListener('resize', setOffset);
    window.addEventListener('orientationchange', setOffset);
    document.addEventListener('shopify:section:load', setOffset);
  }

  /* ── 10. IMAGE ZOOM ON HOVER (DESKTOP) ───────────────────── */
  function initImageZoom() {
    if (window.matchMedia('(pointer: coarse)').matches) return;

    $$('.abaya-product__image-wrap').forEach(function (wrap) {
      on(wrap, 'mousemove', function (e) {
        var rect = wrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top)  / rect.height) * 100;
        var active = $('.abaya-product__img.is-active', wrap);
        if (active) {
          active.style.transformOrigin = x + '% ' + y + '%';
          active.style.transform = 'scale(1.5)';
          active.style.transition = 'none';
        }
      });

      on(wrap, 'mouseleave', function () {
        var active = $('.abaya-product__img.is-active', wrap);
        if (active) {
          active.style.transform = '';
          active.style.transition = 'transform 400ms cubic-bezier(0.16,1,0.3,1)';
        }
      });
    });
  }

  /* ── INIT ──────────────────────────────────────────────────── */
  function init() {
    initGallery();
    initVariantSwitching();
    initQtyStepper();
    initATCFeedback();
    initAccordions();
    initTabs();
    initWishlist();
    initStickyATC();
    initStickyGalleryOffset();
    initImageZoom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Fixed 2026-08: this used to be `addEventListener(..., init)`
     unconditionally. shopify:section:load fires for ANY section, so
     editing the header or footer in the theme editor re-ran init()
     over the untouched, still-mounted product markup and stacked a
     second (then third...) set of listeners on every thumbnail,
     size button, accordion and tab — making accordions toggle twice
     per click and appear stuck. Only re-init when the section that
     actually reloaded contains our markup, in which case the DOM is
     genuinely new and needs binding. */
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e && e.target;
    if (!scope || typeof scope.querySelector !== 'function') return;
    if (scope.querySelector('.abaya-product') || scope.classList.contains('abaya-product')) {
      init();
    }
  });

})();
